// extracted by mini-css-extract-plugin
export var container = "styles-module--container--214c7";
export var customPauseButton = "styles-module--custom-pause-button--63a79";
export var customPlayButton = "styles-module--custom-play-button--e6e5e";
export var customPlayButtonTriangle = "styles-module--custom-play-button-triangle--41ac5";
export var grid = "styles-module--grid--11b0d";
export var likesContainer = "styles-module--likes-container--db2f5";
export var pdp = "styles-module--pdp--208ae";
export var user = "styles-module--user--9cf31";
export var video = "styles-module--video--afe84";
export var videoGridElement = "styles-module--video-grid-element--26c56";